jQuery_T4NT(document).ready(function($) {
  if($(".t4s-product-form__submit .t4s-btn-atc_text").text() == 'Pre-order') {
           $(".preorder-text").show();
         } else {
           $(".preorder-text").hide();
         }
     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     console.log($(".t4s-product-form__submit .t4s-btn-atc_text").text());
         if($(".t4s-product-form__submit .t4s-btn-atc_text").text() == 'Pre-order') {
           $(".preorder-text").show();
         } else {
           $(".preorder-text").hide();
         }
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});

document.addEventListener("DOMContentLoaded", function() {
    // Select all product wrappers
    document.querySelectorAll(".t4s_section_wishlist .t4s-product-wrapper").forEach(wrapper => {
        let vendorDiv = wrapper.querySelector(".t4s-product-vendor"); // Get the vendor div inside the same wrapper
        let productTitle = wrapper.querySelector(".t4s-product-title"); // Get the product title inside the same wrapper

        // Ensure both elements exist before moving
        if (vendorDiv && productTitle) {
            productTitle.insertAdjacentElement("afterend", vendorDiv);
        }
    });
});

function updateButtonText() {
    console.log("Updating button text...");

    document.querySelectorAll("#related_products .t4s-product-btns span.t4s-text-pr").forEach(el => {
        console.log("Found element:", el);

        if (el.textContent.trim() === "Add to cart") {
            console.log("Updating text from 'Add to cart' to 'View Product'");
            el.textContent = "View Product";
        } else {
            console.log("Skipping element, current text:", el.textContent.trim());
        }
    });

    console.log("Button text update complete.");
}

// Run initially
console.log("Running initial update...");
updateButtonText();

// Observe changes in #related_products
const targetNode = document.getElementById("related_products");

if (targetNode) {
    console.log("Setting up MutationObserver...");
    const observer = new MutationObserver((mutations) => {
        console.log("DOM changes detected, running updateButtonText...");
        updateButtonText();
    });

    observer.observe(targetNode, { childList: true, subtree: true });
} else {
    console.log("Error: #related_products not found!");
}
